export const ContextMenuTestIdFactory = {
    // bases
    getContextMenuBase: () => 'context-menu',
    // for test id generation
    getContextMenuTestId: (testId) => [ContextMenuTestIdFactory.getContextMenuBase(), testId].join('-'),
};
